module.exports = __webpack_public_path__ + "img/box_bg7.c000d42.png";